(function () {
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  function drawerEl() { return document.querySelector('cart-drawer'); }
  function route(key, fallback) { return ((window.routes && window.routes[key]) || fallback) + '.js'; }

  function post(path, body) {
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || 'Something went wrong');
        return j;
      });
    });
  }

  function render(json) {
    var d = drawerEl();
    if (!d || typeof d.renderContents !== 'function' || !json.sections) { window.location.reload(); return; }
    if (typeof json.item_count === 'number') d.classList.toggle('is-empty', json.item_count === 0);
    d.renderContents(json);
  }

  var busy = false;
  function change(line, qty) {
    if (busy) return;
    busy = true;
    var inner = document.querySelector('.sm-inner');
    if (inner) inner.classList.add('is-loading');
    post(route('cart_change_url', '/cart/change'), { line: Number(line), quantity: Math.max(0, parseInt(qty, 10) || 0) })
      .then(render)
      .catch(function (e) {
        if (inner) inner.classList.remove('is-loading');
        var err = document.getElementById('CartDrawer-CartErrors');
        if (err) err.textContent = e.message;
      })
      .then(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('cart-drawer [data-sm-qty]');
    if (!b) return;
    e.preventDefault();
    change(b.getAttribute('data-sm-line'), b.getAttribute('data-sm-qty'));
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('cart-drawer .sm-qty__input');
    if (i) change(i.getAttribute('data-sm-line'), i.value);
  });
  document.addEventListener('keydown', function (e) {
    var i = e.target.closest && e.target.closest('cart-drawer .sm-qty__input');
    if (i && e.key === 'Enter') { e.preventDefault(); i.blur(); }
  });

  if (!customElements.get('sm-cart-timer')) {
    customElements.define('sm-cart-timer', class extends HTMLElement {
      connectedCallback() {
        this.key = 'smCartTimerEnd';
        this.dur = (parseFloat(this.dataset.minutes) || 15) * 60000;
        var end = window.__smTimerEnd;
        if (!end) { try { end = parseInt(sessionStorage.getItem(this.key), 10); } catch (e) {} }
        if (!end || end <= Date.now()) end = this.reset();
        window.__smTimerEnd = end;
        this.out = this.querySelector('[data-sm-time]');
        this.tick();
        var self = this;
        this.iv = setInterval(function () { self.tick(); }, 1000);
      }
      disconnectedCallback() { clearInterval(this.iv); }
      reset() {
        var end = Date.now() + this.dur;
        window.__smTimerEnd = end;
        try { sessionStorage.setItem(this.key, String(end)); } catch (e) {}
        return end;
      }
      tick() {
        var left = window.__smTimerEnd - Date.now();
        if (left <= 0) { this.reset(); left = this.dur; }
        var s = Math.floor(left / 1000);
        if (this.out) this.out.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
      }
    });
  }

  if (!customElements.get('sm-upsells')) {
    customElements.define('sm-upsells', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.i = 0;
        this.track = this.querySelector('.sm-ups__track');
        this.n = this.querySelectorAll('.sm-ups__card').length;
        this.addEventListener('click', function (e) {
          var a = e.target.closest('.sm-ups__arrow');
          if (a) { e.preventDefault(); self.go(self.i + Number(a.dataset.dir)); return; }
          var b = e.target.closest('.sm-ups__add');
          if (b) { e.preventDefault(); self.add(b); }
        });
        var x0 = null;
        this.track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        this.track.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) self.go(self.i + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }
      go(i) {
        if (this.n < 2) return;
        this.i = (i + this.n) % this.n;
        this.track.style.transform = 'translateX(-' + this.i * 100 + '%)';
      }
      add(btn) {
        var card = btn.closest('.sm-ups__card');
        var sel = card.querySelector('.sm-ups__variant');
        var err = card.querySelector('.sm-ups__error');
        if (!sel || !sel.value) return;
        var label = btn.textContent;
        btn.disabled = true;
        btn.textContent = '...';
        if (err) err.textContent = '';
        post(route('cart_add_url', '/cart/add'), { items: [{ id: Number(sel.value), quantity: 1 }] })
          .then(render)
          .catch(function (e) {
            if (err) err.textContent = e.message;
            btn.disabled = false;
            btn.textContent = label;
          });
      }
    });
  }
})();
